import React from 'react';
import { Button, ButtonGroup, Heading } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CustomModal } from '@nile/components';

function WarningModal(props) {
  const {
    title,
    description,
    additionalContent,
    primaryBtnText,
    primaryBtnIcon,
    footerButtons,
    active,
    onClose,
    onConfirm
  } = props;

  return (
    <div>
      <CustomModal open={active} onClose={onClose}>
        <div
          style={{ width: props?.modalWidth }}
          className="white-bg br10 tw-p-4"
        >
          <div className="fx tw-gap-2 tw-p-4">
            <div className="fx tw-mt-1">
              <SVGIcon name="WarningIcon" size="lg" color="#FFD68C" />
            </div>
            <div className="fx fcol g10">
              <Heading element="h1" weight="Bold">
                {title || 'title'}
              </Heading>
              <div>{description || 'description'}</div>
              {additionalContent && additionalContent}
            </div>
          </div>
          {footerButtons || (
            <div className="fx actr jend">
              <ButtonGroup spacing="loose">
                <Button plainSecondary onClick={onClose}>
                  <FormattedMessage id="common.cancel" />
                </Button>
                <div onClick={onConfirm}>
                  <Button
                    primary
                    icon={
                      primaryBtnIcon && (
                        <SVGIcon name={primaryBtnIcon} color="#ffffff" />
                      )
                    }
                  >
                    <FormattedMessage id={primaryBtnText || 'common.confirm'} />
                  </Button>
                </div>
              </ButtonGroup>
            </div>
          )}
        </div>
      </CustomModal>
    </div>
  );
}

export default injectIntl(WarningModal);
